/*eslint-disable no-useless-constructor */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import SuppressFields from './Settings/settings';

import Header from '../common/Header/Header';
import { ToastContainer, toast } from 'react-toastify';

import './preference.scss';

class commonPreference extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Container fluid className="claims-details">
          <Header
            linkTo={'/admin/admin-dashboard'}
            header={t(
              'admin.dashboard_modules.reports.renerate_reports_module',
            )}
          />
          <Row>
            <Col>
              <Tabs defaultTab="vertical-tab-one" vertical>
                <TabList>
                  <Tab tabFor="vertical-tab-one" role="navigation">
                    Report Setting
                  </Tab>
                </TabList>

                <TabPanel tabId="vertical-tab-one" className="personal-info">
                  <SuppressFields />
                </TabPanel>
              </Tabs>
              <div className="toastify">
                <ToastContainer
                  draggable
                  pauseOnHover
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  autoClose={5000}
                  position="top-center"
                  newestOnTop={false}
                  hideProgressBar={false}
                  className="toastcontainer"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(commonPreference);
